module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__inner",
    style: (_vm.bodyStyle)
  }, [(_vm.full) ? _c('div', {
    staticClass: "modal__close  modal__close--primary"
  }, [_c('div', {
    staticClass: "modal__close__inner  modal__close__inner--flip"
  }, [(_vm.useWiggleBg) ? _vm._t("wiggle") : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal__close__content"
  }, [_c('div', {
    class: [_vm.closeClass],
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-times text-4xl md:text-5xl cursor-pointer"
  })])])], 2)]) : _vm._e(), _vm._v(" "), (!_vm.full) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "modal__content",
    class: {
      'modal__content--secondary': typeof _vm.secondary !== false
    }
  }, [_vm._t("default")], 2) : _c('div', {
    staticClass: "modal__content",
    class: {
      'modal__content--secondary': typeof _vm.secondary !== false
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-659898e1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Modal.vue
// module id = 1qeA
// module chunks = 1